/**
 * View component for /metric-categories/:metricCategoryId
 *
 * Displays a single metricCategory from the 'byId' map in the metricCategory reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as metricCategoryActions from '../metricCategoryActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';

// import metricCategory components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';

class SingleMetricCategory extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(metricCategoryActions.fetchSingleIfNeeded(match.params.metricCategoryId));
  }

  render() {
    const { location, metricCategoryStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual metricCategory object from the map
     */
    const selectedMetricCategory = metricCategoryStore.selected.getItem();

    const isEmpty = (
      !selectedMetricCategory
      || !selectedMetricCategory._id
      || metricCategoryStore.selected.didInvalidate
    );

    return (
      <AuthoringLayout>
        <Helmet
          title={"Update Single Metric Category | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
              {isEmpty ?
                (metricCategoryStore.selected.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: metricCategoryStore.selected.isFetching ? 0.5 : 1 }}>
                  
                  <div className="yt-row with-gutters">
                    <div className="yt-col full s_60 m_70">
                      <div className="content-container">
                        <div className="yt-row space-between">
                          <p><strong>Metric category details</strong></p>
                          <Link className="yt-btn x-small info" to={`/admin/authoring/metric-categories/${selectedMetricCategory._id}/update`}>Update metric details</Link>
                        </div>
                        <hr/>
                        <small>
                          <strong>Category</strong>
                        </small>
                        <p>{selectedMetricCategory.title}</p>
                        <small>
                          <strong>Order</strong>
                        </small>
                        <p>{selectedMetricCategory.order ? selectedMetricCategory.order : 'n/a'}</p>
                      </div>
                    </div>
                  </div>
                
                </div>
              }
            </div>
          </section>
        </div>
    </AuthoringLayout>
    )
  }
}

SingleMetricCategory.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    metricCategoryStore: store.metricCategory
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleMetricCategory)
);



// WEBPACK FOOTER //
// modules/metricCategory/views/SingleMetricCategory.js.jsx